module.exports = __webpack_public_path__ + "static/media/senseiKendall.cd496c32.jpg";